import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import {cloneDeep} from 'lodash';
import MissionControlHeader from './mission_control_header';
import UpdateCompanyPaymentFailedInternalDataMutation from '../../mutations/mission_control/update_company_payment_failed_internal_data_mutation';
import Moment from 'moment';
import Util from '../../forecast-app/shared/util/util';

class paymentFailedCompanyStats extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sortColumn: 'ID',
			sortAsc: false,
		};
	}

	sort(val) {
		if (this.state.sortColumn === val) {
			this.setState({sortAsc: !this.state.sortAsc});
		} else {
			this.setState({sortAsc: true, sortColumn: val});
		}
	}

	toggleBlock(companyId, id) {
		const blocked = this.props.viewer.missionControlData.paymentFailedCompanyStats.find(company => company.companyId === companyId).accessBlocked;
		Util.CommitMutation(UpdateCompanyPaymentFailedInternalDataMutation, {
			companyId: companyId,
			accessBlocked: !blocked,
		});
	}

	render() {
		if (!this.props.viewer.missionControlData) {
			this.props.history.push('/not-found');
			return null;
		}

		if (!this.props.viewer.missionControlData.paymentFailedCompanyStats) {
			return null;
		}
		const data = cloneDeep(this.props.viewer.missionControlData.paymentFailedCompanyStats);

		const direction = this.state.sortAsc ? 1 : -1;

		if (this.state.sortColumn === 'ID') {
			data.sort((a, b) => {
				return a.companyId > b.companyId ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'NAME') {
			data.sort((a, b) => {
				return (a.companyName || '').toUpperCase() > (b.companyName || '').toUpperCase() ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'PLAN') {
			data.sort((a, b) => {
				return (a.accountPlan || '').toUpperCase() > (b.accountPlan || '').toUpperCase() ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'SEATS') {
			data.sort((a, b) => {
				return a.userSeats > b.userSeats ? direction : direction * -1;
			});
		}

		return (
			<div className="mission-control-list">
				<MissionControlHeader viewer={this.props.viewer} />
				<h1>Company Stats</h1>
				<table>
					<tbody>
						<tr>
							<th onClick={this.sort.bind(this, 'ID')}>Id</th>
							<th onClick={this.sort.bind(this, 'NAME')}>Name</th>
							<th>Payment service ID</th>
							<th>Contact</th>
							<th onClick={this.sort.bind(this, 'SEATS')}>Seats</th>
							<th>Virtual Seats</th>
							<th>Days since Payment</th>
							<th>Amount Due</th>
							<th>Payment Failed Date</th>
							<th>BLOCKED</th>
						</tr>
						{data
							//.filter(data => data.chargebeeId !== null)
							.map(s => {
								const failedPaymentDate = s.failedPaymentDate !== '0' ? Moment(Number(s.failedPaymentDate)).format('DD/MM/YYYY') : 'PAID';
								const toggleBlockButton = <button onClick={this.toggleBlock.bind(this, s.companyId, s.id)}>{s.accessBlocked ? 'Unblock' : 'Block'}</button>;

								return (
									<tr key={s.companyId}>
										<td>{s.companyId}</td>
										<td>{s.companyName}</td>
										<td>
											<a
												href={
													process.env.CIRCLE_BRANCH !== 'production'
														? 'https://forecast-test.chargebee.com/admin-console/customers/' + s.chargebeeId
														: 'https://forecast.chargebee.com/admin-console/customers/' + s.chargebeeId
												}
											>
												{s.chargebeeId}
											</a>
										</td>
										<td>{s.contactEmail}</td>
										<td>{s.userSeats}</td>
										<td>{s.virtualSeats}</td>
										<td>{s.daysSincePayment}</td>
										<td>{'$' + s.amountDue}</td>
										<td>{failedPaymentDate}</td>
										<td>
											{s.accessBlocked ? 'Yes' : 'No'} {toggleBlockButton}
										</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</div>
		);
	}
}

const paymentFailedCompanyStatsQuery = graphql`
	query paymentFailedCompanyStats_Query {
		viewer {
			actualPersonId
			component(name: "control_payment_failed_company_stats")
			...paymentFailedCompanyStats_viewer
		}
	}
`;

export {paymentFailedCompanyStatsQuery};

export default createFragmentContainer(withRouter(paymentFailedCompanyStats), {
	viewer: graphql`
		fragment paymentFailedCompanyStats_viewer on Viewer {
			id
			...missionControlHeader_viewer
			missionControlData {
				id
				paymentFailedCompanyStats {
					id
					companyId
					companyName
					accountPlan
					chargebeeId
					contactName
					contactEmail
					userSeats
					virtualSeats
					daysSincePayment
					amountDue
					failedPaymentDate
					accessBlocked
				}
			}
		}
	`,
});
